import { EObjectType, TFilters } from '@cian/countryside-genplan-component';
import { useEventCallback } from '@cian/react-utils';
import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { fetchGenplanOffer } from 'shared/services/fetchGenplanOffer';

import {
  trackFiltersChange,
  trackGenplanOpen,
  trackGeplanShow,
  trackObjectClick,
  trackPhoneShow,
  trackPreviewClick,
} from './tracking';
import { GenplanBlock } from '../../components/GenplanBlock';
import { GenplanPopupLoadable } from '../../components/GenplanPopup';
import { selectOfferId, selectGenplan } from '../../selectors';
import { useApplicationContext } from '../ApplicationContext';

export const GenplanContainer = () => {
  const context = useApplicationContext();
  const genplan = useSelector(selectGenplan);
  const offerId = useSelector(selectOfferId);

  const [genplanOpened, setGenplanOpened] = React.useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const handlePolygonClick = React.useCallback(
    (objectType?: EObjectType | null) => {
      if (objectType) {
        trackObjectClick(offerId, objectType);
      }
    },
    [offerId],
  );

  const handleTooltipClick = React.useCallback(
    (id: number) => {
      trackPreviewClick(offerId, id);
    },
    [offerId],
  );

  const handleFiltersChange = React.useCallback(
    (filters: TFilters) => {
      trackFiltersChange(offerId, filters);
    },
    [offerId],
  );

  const toggleGenplanOpened = React.useCallback(() => {
    const newValue = !genplanOpened;

    setGenplanOpened(newValue);

    if (newValue) {
      trackGenplanOpen();
    }
  }, [genplanOpened]);

  const offerFetcher = useEventCallback(async (offerId: number) => {
    return fetchGenplanOffer(context, { offerId });
  });

  React.useEffect(() => {
    if (inView) {
      trackGeplanShow();
    }
  }, [inView]);

  if (!genplan) {
    return null;
  }

  return (
    <div ref={ref}>
      <GenplanBlock
        image={genplan.image}
        title="Генплан посёлка"
        genplan={
          genplanOpened ? (
            <GenplanPopupLoadable
              genplan={genplan}
              offerFetcher={offerFetcher}
              onPolygonClick={handlePolygonClick}
              onTooltipClick={handleTooltipClick}
              onFullscreenToggle={toggleGenplanOpened}
              onFilterChange={handleFiltersChange}
              onTooltipPhoneShow={trackPhoneShow}
              focusedId={offerId}
            />
          ) : null
        }
        onClick={toggleGenplanOpened}
      />
    </div>
  );
};
